<style scoped>
  @import "../../../assets/css/table-list.css";
</style>
<template>
  <div>
    <h3 class="title">产权信息列表</h3>
    <div class="margin-bottom-10 header-group">
      <Select v-model="params.CondList[0].Key">
        <Option v-for="(item,index) in d_search_key" :value="item.value" :key="index">{{ item.label }}</Option>
      </Select>
      <Input v-model="params.CondList[0].Value" placeholder="请输入搜索内容"/>
      <Button type="primary" @click="search()">查询</Button>
      <Button type="primary" @click="to_add()" class="right">新增</Button>
      <Button type="primary" @click="to_export" class="btn-right" :loading="loading_export">导出</Button>
      <Button type="primary" @click="to_export('all')" class="btn-right" :loading="loading_export_all">导出全部</Button>
    </div>
    <div>
      <Table ref="selection" border :columns="d_columns" :data="d_data" @on-selection-change="get_select_data"></Table>
      <div class="margin-top-20">
        <Page :total="d_total" show-sizer show-total @on-change="flip" :page-size-opts="[10, 20, 50, 100]" @on-page-size-change="change_size" class="pull-right"></Page>
        <div class="clear-both"></div>
      </div>
    </div>
    <Modal
      v-model="d_modal_add"
      :title="d_modal_title"
      width="800px"
      footer-hide>
      <Form ref="formValidate" :model="add_params" :rules="ruleValidate" :label-width="80">
        <Row>
          <Col span="12">
            <FormItem label="产权证号" prop="PropNum" v-if="d_modal_type=='edit'">
              <Input v-model="add_params.PropNum" disabled></Input>
            </FormItem>
            <FormItem label="产权证号" prop="PropNum" v-else>
              <Input v-model="add_params.PropNum" placeholder="请输入产权证号"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="项目名称" prop="ProjName">
              <Input v-model="add_params.ProjName" placeholder="请输入项目名称"></Input>
            </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="面积" prop="Area">
            <Input v-model="add_params.Area" placeholder="请输入面积" class="all-input-margin"></Input>平米
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="产权证" prop="FileList">
            <Upload
              ref="propImgList"
              :default-file-list="d_defaultList"
              :action="$store.state.app.baseUrl + '/api/Pub/UploadFile?outType=prop&&type=产权证'"
              multiple
              :headers="{Authorization:token}"
              :on-preview="img_preview">
              <Button icon="ios-cloud-upload-outline">请选择文件</Button>
            </Upload>
            <Modal title="图片预览" v-model="d_img_visible" @on-cancel="cancel_preview" footer-hide>
              <img :src="d_img_name" v-if="d_img_visible" style="width: 100%">
            </Modal>
          </FormItem>
          </Col>
        </Row>
        <FormItem label="地址" prop="addr">
          <area-select type="text" :level="2" :data='pcaa' v-model="d_selected_addr" size="small" ></area-select>
        </FormItem>
        <FormItem label="详细地址" prop="Address">
          <Input v-model="add_params.Address" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入详细地址"></Input>

          <Collapse simple class="no-border-top">
            <Panel name="1">
              选择具体地址：<span v-if="add_params.Latitude" class="margin-left10">经维度（ {{ add_params.Latitude }}，{{ add_params.Longitude }}）</span>
             <div slot="content">
               <div class="amap-wrapper map-group">
                 <el-amap-search-box class="search-box" :search-option="d_map.searchOption" :on-search-result="map_onSearchResult"></el-amap-search-box>
                 <el-amap vid="amapDemo"  :center="d_map.mapCenter" :zoom="d_map.zoom" class="amap-demo">
                   <el-amap-marker v-for="marker in d_map.markers" :position="marker" ></el-amap-marker>
                 </el-amap>
               </div>
               <div><Button type="primary" class="map_btn" @click="map_confirm">确认</Button></div>
             </div>
            </Panel>
          </Collapse>

        </FormItem>
        <FormItem label="备注" prop="Notes">
          <Input v-model="add_params.Notes" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
        </FormItem>

        <FormItem>
          <Button type="primary" @click="edit_confirm('formValidate')">保存</Button>
          <Button @click="add_modal_cancel" class="margin-left10">取消</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import 'vue-area-linkage/dist/index.css';
  import apiProp from '@/api/prop.js';
  import mixin from '@/components/common/mixin.js';
  import { pca, pcaa } from 'area-data';
  export default {
    name:'propInfo',
    mixins: [mixin],
    data() {
      return {
        token:'',
        pcaa:pcaa,
        params: {},
        add_params:{},
        ruleValidate: {
          PropNum: [
            { required: true, message: '产权证号为必填项', trigger: 'blur' }
          ],
          ProjName: [
            { required: true, message: '项目名称为必填项' , trigger: 'blur'}
          ],
          Area: [
            { required: true, message: '面积为必填项', trigger: 'blur' },
            { type: 'string',pattern:/^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/, message:'面积必须大于0小于131072的数字', trigger:'blur'}
          ]
        },
        d_total: 0,
        d_page: 1,
        d_page_size: 10,
        d_search_key:[
          {
            value: 'p.PropNum',
            label: '产权证号'
          },
          {
            value: 'p.ProjName',
            label: '所属项目'
          },
          {
            value: 'p.Province',
            label: '省'
          },
          {
            value: 'p.City',
            label: '市'
          },
          {
            value: 'p.County',
            label: '区'
          },
          {
            value: 'p.Address',
            label: '详细地址'
          }
        ],
        d_modal_add: false,
        d_modal_title: '',
        d_columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '所属项目',
            key: 'ProjName',
            minWidth: 100
          },
          {
            title: '产权证号',
            key: 'PropNum',
            minWidth: 40
          },
          {
            title: '产权面积/㎡',
            key: 'Area',
            minWidth: 40
          },
          {
            title: '房屋坐落',
            key: 'addr',
            minWidth:120
          },
          {
            title: "操作",
            key: "do",
            fixed:'right',
            width:200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.to_edit(params.row);
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: "<p>您确认要删除该条数据吗？</p>",
                          onOk: () => {
                            this.to_delete(params.row.PropNum);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ])
            }
          }
        ],
        d_data: [],
        d_modal_type: '',
        d_selected_addr:["四川省", "成都市", "武侯区"],
        d_map:{
          zoom:16,
          markers: [],
          searchOption: {
            city: '成都',
            citylimit: true//是否限制城市内搜索
          },
          mapCenter: [104.07645540000001, 30.677688999999997],//默认中心在成都
          lng: 0,
          lat: 0,
          loaded: false
        },
        d_defaultList:[],
        d_del_data:'', // 批量删除
        loading_export:false,
        loading_export_all:false,
      };
    },
    methods: {
      search() {
        this.params.PageIndex = 1;
        this.pull_data();
      },
      change_condList(value){
        if((value=='p.PropNum') || (value=='p.ProjName') || (value=='p.Address')){
          this.params.CondList[0].Operator = 'like';
        }else {
          this.params.CondList[0].Operator = '=';
        }
      },
      flip(page) { //翻页条件，每页多少条，多少页
        this.params.PageIndex = page;
        this.params.PageSize = this.d_page_size;
        this.pull_data();
      },
      change_size(size) { //改变limit 每页显示多少条
        this.params.PageSize = size;
        this.pull_data();
      },
      pull_data() {
        let _this = this;
        apiProp.getList.post(this.params).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录成功+执行成功
            let requestResult = _data.data.Data;
            let rowsList = requestResult.RowsList;
            for (let i = 0; i < rowsList.length; i++) { // 判断有效期
              rowsList[i].addr = rowsList[i].Province+''+rowsList[i].City+''+rowsList[i].County+''+rowsList[i].Address;
            }
            _this.d_total = requestResult.Total;  // 数据数量统计
            _this.d_data = rowsList; //数据列表开始
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      to_add(){
        this.d_modal_add = true;
        this.d_modal_type = 'add';
        this.d_modal_title = '添加产权';
        this.add_params = JSON.parse(JSON.stringify(apiProp.add.data));
      },
      to_edit(row){
        this.d_modal_type = 'edit';
        this.d_modal_title = '修改产权';
        if(!row.PropNum) {
          this.$Message.error('没有产权证号，此条数据作废');
          return;
        }
        apiProp.getEditDto(row.PropNum).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.add_params = _data.data.Data;
            this.add_params.Area = this.add_params.Area+'';
            let fileList = this.add_params.FileList;
            let defaultList = [];
            for(let i=0;i<fileList.length;i++){
              let thisFile = {};
              thisFile.name = fileList[i].SaveName;
              thisFile.url = fileList[i].SaveName;
              defaultList.push(thisFile);
            }
            this.d_defaultList = defaultList;
            this.d_selected_addr = [];
            this.d_selected_addr = [this.add_params.Province,this.add_params.City,this.add_params.County]
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
//        图片赋值
//        this.$refs['formValidate'].validate((valid)=> {});//重新验证，不然会有提示
        this.d_modal_add = true;
      },
      add_modal_cancel(){
        this.d_modal_add = false;
      },
      edit_confirm (name) {
        let _this = this;
        let propImgList = this.$refs.propImgList.fileList;
        let fileList = [];
        if(propImgList.length>0){
          for(let i=0;i<propImgList.length;i++){
            let currFile = {};
            currFile.OutType = 'prop';
            currFile.Type = '产权证'; // 编辑的时候要传个id，具体看接口文档 to do（所有的上传都要改，还有其他参数）
            if(propImgList[i].response){
              currFile.SaveName = propImgList[i].response.Data;
            }else {
              currFile.SaveName = propImgList[i].name;
            }
            fileList.push(currFile);
          }
        }
        this.add_params.FileList = fileList;
        this.add_params.Province =this.d_selected_addr[0];
        this.add_params.City =this.d_selected_addr[1];
        this.add_params.County =this.d_selected_addr[2];
        this.$refs[name].validate((valid) => {
          if (valid) {
            if( Number(this.add_params.Area)>131072 ){
              this.$Message.error('商铺面积不能大于 "131072" !');
              return;
            }
            this.submit_edit_data();
          } else {
            this.$Message.error('验证失败!');
          }
        })
      },
      submit_edit_data(){
        let _this = this;
        this.add_params.Area = Number.parseFloat(Number(this.add_params.Area).toFixed(2));
        if(_this.d_modal_type=='add'){
          apiProp.add.post(this.add_params).then((_data) => {
            if(_data.data.ExeSuccess && _data.data.LoginSuccess){
              this.d_modal_add = false;
              this.$refs.propImgList.clearFiles(); //不知道这句话在这里是否有用
              this.pull_data();
            }else {
              this.$Message.error(_data.data.Msg);
            }
          });
        }else if(_this.d_modal_type=='edit'){

          apiProp.edit.post(this.add_params).then((_data) => {
            if(_data.data.ExeSuccess && _data.data.LoginSuccess){
              this.d_modal_add = false;
              this.$refs.propImgList.clearFiles();
              this.pull_data();
            }else {
              this.$Message.error(_data.data.Msg);
            }
          });
        }
      },
      to_delMore(){
        if(this.d_del_data.length>0){
          this.$Modal.confirm({
            title: "提示",
            content: "<p>您确认要删除这组数据吗？</p>",
            onOk: () => {
              this.to_delete(this.d_del_data);
            },
            onCancel: () => {}
          });
        }else {
          this.$Message.warning('请选择要删除的列');
        }
      },
      get_select_data(row){
        let delData = '';
        for(let i=0;i<row.length;i++){
          delData+=row[i].PropNum+',';
        }
        delData=(delData.substring(delData.length-1)==',')?delData.substring(0,delData.length-1):delData; // 去掉末尾逗号
        this.d_del_data = delData;
      },
      to_delete(_idList){
        apiProp.del(_idList).then((_data) => { //传数组删除不了，传string才能删除的
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.$Message.success('删除成功');
            this.pull_data();
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      map_confirm(){
        this.add_params.Latitude = this.d_map.mapCenter[1];
        this.add_params.Longitude = this.d_map.mapCenter[0];
      },
      map_onSearchResult(pois) {
        let latSum = 0;
        let lngSum = 0;
        if (pois.length > 0) {
          pois.forEach(poi => {
            let {lng, lat} = poi;
            lngSum += lng;
            latSum += lat;
          });
          let center = {
            lng: lngSum / pois.length,
            lat: latSum / pois.length
          };
          this.d_map.mapCenter = [center.lng, center.lat];
          this.d_map.markers.push([center.lng, center.lat]);
        }
      },
      to_export(_type){ //导出
        // let condList = this.params.CondList[0];
        // if(condList.Value ===''){
        //   delete this.params.CondList;
        // }
        let _this = this;
        if(_type==='all'){
          this.params.PageIndex = 1;
          this.params.PageSize = 10000000;
          this.loading_export_all = true
        }else {
          this.loading_export = true
        }
        apiProp.export.post(this.params).then((_data) => {
          if(_data.data){
           setTimeout(function () {
             _this.loading_export = false;
             _this.loading_export_all = false;
           },1000)
            let blob = _data.data;
            let reader = new FileReader();
            reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
            reader.onload = function (e) {
              // 转换完成，创建一个a标签用于下载
              let a = document.createElement('a');
              a.download = '产权列表.xlsx';
              a.href = e.target.result;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }
          }else {
            this.$Message.error('导出报表出错');
          }

        });
      }
    },
    created() {
      this.params = JSON.parse(JSON.stringify(apiProp.getList.data));
      this.add_params = JSON.parse(JSON.stringify(apiProp.add.data));
      this.pull_data();
    },
    mounted(){
      this.params.CondList[0].Key = 'p.PropNum';
      this.params.CondList[0].Operator = 'like'; //默认全部为模糊搜索
      this.token = sessionStorage.getItem('token');
    }
  }
</script>






